import {
  CalendarDays,
  Cookie,
  FileLock2,
  GraduationCap,
  Handshake,
  Headset,
  House,
  LayoutDashboard,
  LayoutGrid,
  Library,
  LogOut,
  Rocket,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Store,
  Users,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * One registry for every place that shows a service or a utility action: the
 * sidebar, the overview cards and the user menu. The keys match the `icon` field
 * in the navigation config, which in turn matches the service ids, so a service
 * looks the same wherever it appears.
 *
 * The mapping is deliberate rather than derived. A hash over the id would be
 * stable but arbitrary, and Support would end up with a shopping cart.
 */
export const navIcons: Record<string, LucideIcon> = {
  home: House,
  dashboard: LayoutDashboard,
  academy: GraduationCap,
  community: Users,
  launchpad: Rocket,
  support: Headset,
  shop: ShoppingCart,
  portfolio: Handshake,
  library: Library,
  marketplace: Store,
  booking: CalendarDays,
  settings: Settings,
  cookie: Cookie,
  shield: ShieldCheck,
  policy: FileLock2,
  logout: LogOut,
};

/** Services injected through the runtime config may not be in the registry. */
export const getNavIcon = (name: string | undefined): LucideIcon =>
  (name && navIcons[name]) || LayoutGrid;
